module.exports = __webpack_public_path__ + "assets/img/img132.c4c997a1.png";